import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { LayoutLegacy } from "@silvertours/front-legacy-entities";
import { ColumnContent } from "./ColumnContent";
var RATIO = [
    LayoutLegacy.ColumnRatioOption.One,
    LayoutLegacy.ColumnRatioOption.Two, 
];
var ColumnsModule = function(param) {
    var _columns = _sliced_to_array(param.columns, 2), column1Content = _columns[0], column2Content = _columns[1], id = param.id;
    return /*#__PURE__*/ _jsx(LayoutLegacy.TwoColumns, {
        ratio: RATIO,
        id: id,
        children: function(Column1, Column2) {
            return [
                /*#__PURE__*/ _jsx(Column1, {
                    children: /*#__PURE__*/ _jsx(ColumnContent, {
                        content: column1Content
                    })
                }),
                /*#__PURE__*/ _jsx(Column2, {
                    children: /*#__PURE__*/ _jsx(ColumnContent, {
                        content: column2Content
                    })
                }), 
            ];
        }
    });
};
export { ColumnsModule };
